module.exports = __webpack_public_path__ + "img/xuebitu.3ba77210.jpg";